import axios from "axios"
import apiClient from './apiClient'; // Import the custom client

export const fetchAllAttachments = async (cancelToken) => {
    try { 
        const { data } = await axios.get(`/api/attachments`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const attachFile = (file,isWipPDF) => {
    return axios.post(`/api/attachments`, file)
};

export const getFile = (file)=>{
    // Use apiClient instead of axios
    return apiClient.get(`/api/attachments/${file}`);
}

export const deleteFile = (payload) => {
    return axios.delete(`/api/attachments/${payload.WIID}/${payload.filePath}`)
};

export const fetchAllAttachmentByType=(type)=>{

    return axios.get(`/api/attachments/type/${type}`)

}

export const checkIfAttachmentExists=(file)=>{
    return axios.get(`/api/attachments/checkattachmentexists/${file}`)
}

export const softDeleteAttachment = (attachmentId) => {
    return axios.delete(`/api/attachments/soft-delete/${attachmentId}`)
}
